import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@artosera/ui';
import { boiteApi, type Message } from '../../api/boite-reception.js';
import { enregistrerFichier } from '../../api/client.js';
import { useShellContext } from '../shell/context.js';
import { useGesteBoite } from './useGesteBoite.js';
import styles from './Boite.module.css';
export function MessageEntrant({ message }: { message: Message }) {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation('regie');
  const [html, setHtml] = useState<string | null>(null);
  const charger = useGesteBoite((_: void, appel) => boiteApi.html(galerieSlug, message.id, appel));
  return (
    <>
      <p className={styles.texte}>{message.texte}</p>
      {message.tronque ? <p>{t('boiteReception.tronque')}</p> : null}
      {message.htmlDisponible ? (
        <Button
          variant="secondary"
          loading={charger.pending}
          onClick={() => {
            void charger.executer().then((contenu) => {
              if (contenu !== undefined) setHtml(contenu);
            });
          }}
        >
          {t('boiteReception.afficherHtml')}
        </Button>
      ) : null}
      {charger.erreur ? <p role="alert">{charger.erreur}</p> : null}
      {html !== null ? (
        <iframe
          className={styles.cadre}
          title={t('boiteReception.miseEnForme')}
          sandbox="allow-popups allow-popups-to-escape-sandbox"
          srcDoc={`<meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'"><style>:root{color-scheme:light}body{background:Canvas;color:CanvasText;font:16px sans-serif;overflow-wrap:anywhere}table{max-width:100%;border-collapse:collapse}td,th{padding:4px}</style>${html}`}
        />
      ) : null}
      <PiecesJointes message={message} />
    </>
  );
}
export function PiecesJointes({ message }: { message: Message }) {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation('regie');
  const telecharger = useGesteBoite((piece: string, appel) =>
    boiteApi.piece(galerieSlug, message.id, piece, appel),
  );
  return (
    <>
      {message.piecesJointes.length ? (
        <ul>
          {message.piecesJointes.map((p) => (
            <li key={p.id}>
              {p.etat === 'saine' ? (
                <a
                  href="#"
                  download={p.nom}
                  onClick={(e) => {
                    e.preventDefault();
                    void telecharger.executer(p.id).then((f) => {
                      if (f) enregistrerFichier(f, p.nom);
                    });
                  }}
                >
                  {p.nom}
                </a>
              ) : (
                <span>
                  {p.nom} — {t(`boiteReception.pieces.${p.etat}`)}
                </span>
              )}
            </li>
          ))}
        </ul>
      ) : null}
      {telecharger.erreur ? <p role="alert">{telecharger.erreur}</p> : null}
    </>
  );
}
